import React from 'react';

export default function Spinner({ colour, centerMode })
{
    const styles = {}

    if (colour) {
        styles['borderLeftColor'] = colour;
    }

    if (centerMode) {
        styles['margin'] = 0;
    }

    return <div style={ styles } className={'spinner'} />
}
